import { useQuery } from '@tanstack/react-query';
import { listarFuentes } from '@/api/cartera.api';

/**
 * T14: los nombres de las fuentes que ya existen, para proponerlos al importar, al crear un
 * cliente o al cambiarle la fuente. Es la misma consulta de la vista «Fuentes» (`['cartera',
 * 'fuentes']`): lo que se cambia en Clientes la refresca. Si no se puede leer, lista vacía: igual
 * se puede escribir una nueva.
 */
export function useFuentes(): string[] {
  const { data } = useQuery({ queryKey: ['cartera', 'fuentes'], queryFn: listarFuentes, retry: false, staleTime: 60_000 });
  return data?.map((s) => s.fuente) ?? [];
}
